import{useLayoutEffect as e,useEffect as f}from"react";const t=typeof window!="undefined"?e:f;export{t as useIsoMorphicEffect};
